<template>
  <v-date-input
    v-model="parsedDate"
    color="primary"
    prepend-icon=""
    prepend-inner-icon="$calendar"
    :label="title"
    :value="moment(parsedDate).format('DD.MM.YYYY')"
  ></v-date-input>
</template>

<script setup lang="ts">
import moment from 'moment'
import { computed, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import type { SchemaFormKitProps } from './formkit/types'

const props = defineProps<SchemaFormKitProps>()
const model = defineModel<string>()
const parsedDate = ref<Date>(null)

const { t, te } = useI18n()

const title = computed(() => {
  if (!props.field.properties?.title) return 'Datum'

  return te(props.field.properties.title)
    ? t(props.field.properties.title)
    : props.field.properties.title
})

onMounted(() => {
  if (model.value) parsedDate.value = moment(model.value).toDate()
  else parsedDate.value = moment().startOf('day').toDate()
})

watch(parsedDate, (newValue) => {
  model.value = newValue.toISOString()
})
</script>
